import { render, staticRenderFns } from "./ProuniFileUpload.vue?vue&type=template&id=6d0b74b3&scoped=true&"
import script from "./ProuniFileUpload.vue?vue&type=script&lang=ts&"
export * from "./ProuniFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniFileUpload.vue?vue&type=style&index=0&id=6d0b74b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b74b3",
  null
  
)

export default component.exports